import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IClient } from '../types';
import { ClientRow } from './client-row';

interface Props {
  tableProps: TableProps;
  rows?: IClient[];
  loading?: boolean;
  canAddClient: string;
}

const ClientList = ({ tableProps, rows, loading, canAddClient }: Props) => {
  const TABLE_HEAD = [
    { id: 'id', label: 'Id', align: 'center' },
    { id: 'firstName', label: 'Name', align: 'center' },
    { id: 'email', label: 'Email', align: 'center' },
    { id: 'phone', label: 'Phone', align: 'center', sortable: false },
    { id: 'status', label: 'Status', align: 'center', sortable: false },
    ...(canAddClient ? [{ id: 'Action', label: 'Action', align: 'center', sortable: false }] : []),
  ];
  return (
    <PaginatedTable<IClient>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <ClientRow
          row={row}
          canAddClient={canAddClient}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};
export { ClientList };
